/*
 * @Author: liyxt
 * @Date: 2020-05-28 11:40:24
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:47:02
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginForm from 'bee-form';

require('bee-form/build/Form.css');
require('./index.less');
// 这个组件  从可这边使用了

class Form extends Component {
	render() {
		return <OriginForm {...this.props} />;
	}
}

Form.FormItem = OriginForm.FormItem;
export default Form;
